export class Field {
    constructor() {
        if (this.constructor == Field) {
            throw new Error("Abstract classes can't be instantiated.");
        }

        this._label = null;
        this._validation = {};
        this._component = null;
    }

    component(value) {
        this._component = value;
        return this;
    }

    label(value) {
        this._label = value;
        return this;
    }

    required(allowFalse = false) {
        this._validation = {...this._validation, ...{required: {allowFalse}}};
        return this;
    }

    validation(value) {
        this._validation = {...this._validation, ...value};
        return this;
    }
}
